module.exports = __webpack_public_path__ + "static/media/blog-admin-min.e2011e27.png";